import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { OrderService } from 'src/app/services/order/order.service';

@Component({
  selector: 'app-payment-options',
  templateUrl: './payment-options.page.html',
  styleUrls: ['./payment-options.page.scss'],
})
export class PaymentOptionsPage implements OnInit {
  @Input() invoiceNo: string;
  @Input() docID: string;
  @Input() userID: string;
  @Input() deliveryFee: number;
  @Input() selectedMethod: string;

  paymentMethod;
  methodSelected = false;

  constructor(
    private router: Router,
    private modalCtrl: ModalController,
    private orderService: OrderService
  ) {}

  ngOnInit() {
    if (this.selectedMethod) {
      this.paymentMethod = this.selectedMethod;
      this.methodSelected = true;
    }
  }

  onSelectMethod(e) {
    this.paymentMethod = e.detail.value;
    this.methodSelected = true;
  }

  closeModal() {
    this.modalCtrl.getTop().then((res) => {
      if (res) {
        this.modalCtrl.dismiss();
      }
    });
  }

  pay() {
    if (this.paymentMethod === 'Card-Payment') {
      this.closeModal();
      this.router.navigate(['/make-payment'], {
        queryParams: { invoiceNo: this.invoiceNo },
      });
    } else if (this.paymentMethod === 'Wallet') {
      this.closeModal();
      this.router.navigate(['/wallet-method'], {
        queryParams: {
          invoiceNo: this.invoiceNo,
          userID: this.userID,
          deliveryFee: this.deliveryFee,
          docID: this.docID,
        },
      });
    } else if (this.paymentMethod === 'Cash') {
      this.orderService.updateOrder(this.docID, this.paymentMethod).then(() => {
        alert('Cash Payment will be paid on delivery');
        this.closeModal();
      });
    }
  }
}
